export const PREFERRED_LANGUAGES = [
  {
    id: 1,
    name: 'Français',
    acronym: 'fr',
  },
  {
    id: 2,
    name: 'Deutsch',
    acronym: 'de',
  },
] as const;
